
export default {
  head() {
    return {
      title: "Création site internet Reims | À partir 69€HT/mois",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous voulez créer un site web pour votre entreprise à Reims ? Contactez l’agence de communication ALEO pour découvrir ses solutions digitales à prix accessible !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Création site internet Reims | À partir 69€HT/mois",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous voulez créer un site web pour votre entreprise à Reims ? Contactez l’agence ALEO pour découvrir ses solutions digitales à prix accessible !",
        },
      ],
    };
  },
};
